import React from 'react';
import { Box, Button, Divider, Typography, InputLabel } from '@mui/material';
const TemplePage = () => {
  return <Box>ggfffgf</Box>;
};

export default TemplePage;
